import { combineReducers } from "redux";
import { formReducer } from "./FuelComposition/FuelComposition.reducer";
import { loginReducer } from "./Login/Login.reducer";
import { logboxReducer } from "./LogBox/LogBox.reducer";
import { millSelectorReducer } from "./MillSelector/MillSelector.reducer";
import { timeSelectorReducer } from "./TimeSelector/TimeSelector.reducer";
import { StoreState } from "../models";
import { dampersReducer } from "./Dampers/Dampers.reducer";
import { startupBurnerOverrideReducer } from "./StartupBurnerOverride/StartupBurnerOverride.reducer";

export const reducers = combineReducers<StoreState>({
  logbox: logboxReducer,
  login: loginReducer,
  millSelector: millSelectorReducer,
  timeSelector: timeSelectorReducer,
  fuelComposition: formReducer,
  dampers: dampersReducer,
  startupBurnerOverride: startupBurnerOverrideReducer,
});
